import { render } from "./Settings-JailCallMenuEditor-PropertiesDialog.vue?vue&type=template&id=528ac16c&scoped=true"
import script from "./Settings-JailCallMenuEditor-PropertiesDialog.vue?vue&type=script&lang=js"
export * from "./Settings-JailCallMenuEditor-PropertiesDialog.vue?vue&type=script&lang=js"

import "./Settings-JailCallMenuEditor-PropertiesDialog.vue?vue&type=style&index=0&id=528ac16c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528ac16c"]])

export default __exports__